module.exports = __webpack_public_path__ + "static/img/lpnsj_1@2x.1b308a5e.png";